import localScaleManager from "../../../../helpers/LocalScaleManager";
import { Parser } from "../../../../helpers/parser";

export class TextMessage {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   */
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.isMyTable = false;
    this.bg = this.scene.add.image(
      0,
      0,
      this.scene.atlasTexture,
      "player-message-box"
    );
    this.table.poolArray.push(this.bg);
    this.bg.setDepth(11);

    this.maxTextLength = 20;
    // this.text = this.scene.add.text(0, 0, 'myRaid', Parser.convertToXLetters("salam salam salam salam salam", this.maxTextLength));
    this.text = this.scene.add.text(0, 0, "", {
      fontFamily: "Vazir",
      fontSize: 1,
      color: "#ffffff",
      align: "center",
    });
    this.table.poolArray.push(this.text);

    // this.text.setData("width", this.text.width);
    // this.text.setData("height", this.text.height);
    this.text.setText(
      Parser.convertToXLetters(
        "salam salam salam salam salam",
        this.maxTextLength + 2
      )
    );
    this.text.setTint(0x00e0c7).setOrigin(0.5);
    this.text.setDepth(12);

    this.bgInitScaleX = 0;

    this.group = this.scene.add.group([this.bg, this.text]);
    Phaser.Actions.SetAlpha(this.group.getChildren(), 0);
    this.table.poolArray.push(this.group);

    this.showTimer = null;
    this.isHiding = false;
  }
  hide() {
    if (this.isHiding) return;
    this.isHiding = true;
    this.scene.tweens.add({
      targets: this.group.getChildren(),
      duration: 200,
      ease: "Back",
      y: `+=${this.bg.displayHeight}`,
      alpha: 0,
      onComplete: () => {
        Phaser.Actions.IncY(this.group.getChildren(), -this.bg.displayHeight);
        this.isHiding = false;
      },
    });
  }
  visibilityControls(visibility) {
    if (this.bg.visible !== visibility) this.bg.setVisible(visibility);
  }
  updateText(text) {
    if (text.length <= this.maxTextLength) {
      this.text.setText(text);
      const scaleY = text.length >= 13 ? 1.8 : 1;
      this.bg.setScale(
        (this.bgInitScaleX * (text.length + 6)) / this.maxTextLength,
        scaleY
      );
    } else {
      this.text.setText(Parser.convertToXLetters(text, this.maxTextLength));
      this.bg.setScale(this.bgInitScaleX, 1.5);
    }
    // this.text.setWordWrapWidth(this.bg.displayWidth * 3/4)
    // this.bg.width = this.text.width;
    // this.bg.height = this.text.height;
    // this.bg.setScale(this.text.scale)
  }
  showText(text) {
    if (this.isHiding) return;
    this.updateText(text);
    Phaser.Actions.IncY(this.group.getChildren(), this.bg.displayHeight);
    if (this.showTimer) {
      this.showTimer.paused = true;
      this.hide();
    }
    this.scene.tweens.add({
      targets: this.group.getChildren(),
      duration: 200,
      ease: "Back",
      y: `-=${this.bg.displayHeight}`,
      alpha: 1,
      onComplete: () => {
        this.showTimer = this.scene.time.addEvent({
          delay: 3000, // ms
          callback: this.hide,
          callbackScope: this,
          repeat: 1,
        });
      },
    });
  }
  /***
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(width, height, initX, initY, isMyTable) {
    this.isMyTable = isMyTable;
    const bgSize = isMyTable ? width : width * 1.7;
    // const bgSize = width * 1.7;
    localScaleManager.scaleSprite(
      this.bg,
      bgSize,
      bgSize,
      0,
      1,
      true
    );
    this.bg.setPosition(initX + width / 2, initY - height * 1.1);

    this.bgInitScaleX = this.bg.scaleX;

    // localScaleManager.scaleText(this.text, this.bg.displayWidth, this.bg.displayHeight * 3 / 4  ,5 , 1, false);
    this.text.setPosition(this.bg.x, this.bg.y);
    this.text.setFontSize(this.bg.displayHeight / 2);
    this.text.setWordWrapWidth((this.bg.displayWidth * 3) / 4);
  }
  /***
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  reposition(width, height, initX, initY, isMyTable) {
    this.isMyTable = isMyTable;
    this.bg.setPosition(initX + width / 2, initY - height * 1.1);
    this.text.setPosition(this.bg.x, this.bg.y);
  }
}
